module.exports = __webpack_public_path__ + "img/racetrack-durbanville-turf.966da9ab.svg";